import instance from '../index';
import { market, roadshow, common } from '../interface';

// 公共筛选条件 1-路演 5-调研 27-研报 32-问答 24-纪要 37: 业绩披露
export const getNewFilterConfigList = async (data, config = {}) => {
  return await instance.post(common.getNewFilterConfigList, data, config);
};

export const queryRoadshowList = async (data, config = {}) => {
  return await instance.post(roadshow.companyList, data, config);
};

// 行业详情（新）
export const queryIndustryDetailNew = async (data, config = {}) => {
  return await instance.post(market.queryIndustryDetail, data, config);
};

// 中证全指
export const queryCSIAllIndex = async (data, config = {}) => {
  return await instance.post(market.queryCSIAllIndex, data, config);
};

// 市场&行业热度
export const queryMarketIndustryTrend = async (data, config = {}) => {
  return await instance.post(market.queryMarketIndustryTrend, data, config);
};

// 因子选股保存
export const saveFactorStock = async (data, config = {}) => {
  return await instance.post(market.saveFactorStock, data, config);
};

// 因子选股详情
export const factorStockDetail = async (data, config = {}) => {
  return await instance.post(market.factorStockDetail, data, config);
};

// 因子选股股票列表
export const factorStockList = async (data, config = {}) => {
  return await instance.post(market.factorStockList, data, config);
};

// 市场热度趋势
export const discoveryMarketTrend = async (data, config = {}) => {
  return await instance.post(market.discoveryMarketTrend, data, config);
};

// 个股热度趋势
export const discoveryStockTrend = async (data, config = {}) => {
  return await instance.post(market.discoveryStockTrend, data, config);
};

// 个股相对一级行业热度趋势
export const discoveryStockIndustryRelateTrend = async (data, config = {}) => {
  return await instance.post(market.discoveryStockIndustryRelateTrend, data, config);
};

// 行业热度趋势
export const discoveryIndustryTrend = async (data, config = {}) => {
  return await instance.post(market.discoveryIndustryTrend, data, config);
};

// 发现页热门/冷门行业
export const queryIndustryHeatList = async (data, config = {}) => {
  return await instance.post(market.queryIndustryHeatList, data, config);
};

// 热门行业
export const queryIndustryHeat = async (data, config = {}) => {
  return await instance.post(market.queryIndustryHeat, data, config);
};

// 热门行业分布
export const queryIndustryHeatDistribution = async (data, config = {}) => {
  return await instance.post(market.queryIndustryHeatDistribution, data, config);
};

// 发现页热门股票
export const queryHotStocks = async (data, config = {}) => {
  return await instance.post(market.queryHotStocks, data, config);
};

// 获取行业龙头公司
export const getIndustryCompanyList = async (data, config = {}) => {
  return await instance.post(market.getIndustryCompanyList, data, config);
};

// 行业列表查询
export const getIndustryList = async (data, config = {}) => {
  return await instance.post(market.getIndustryList, data, config);
};

// 详情页行业热榜
export const queryHotIndustry = async (data, config = {}) => {
  return await instance.post(market.queryHotIndustry, data, config);
};

// 详情页通过行业查热门个股
export const queryHotStockByIndustry = async (data, config = {}) => {
  return await instance.post(market.queryHotStockByIndustry, data, config);
};

// 详情页通过分组查热门个股
export const queryHotStockByGroup = async (data, config = {}) => {
  return await instance.post(market.queryHotStockByGroup, data, config);
};

// 获取行业标签
export const queryTagIndustry = async (data, config = {}) => {
  return await instance.post(common.queryTagIndustry, data, config);
};

// 获取个股收盘价数据
export const queryStockClosePrice = async (data, config = {}) => {
  return await instance.post(market.queryStockClosePrice, data, config);
};

// 获取个股行为数据
export const queryStockBehavior = async (data, config = {}) => {
  return await instance.post(market.queryStockBehavior, data, config);
};

// 获取日k打点（通过类型获取）
export const queryStockDailyCount = async (data, config = {}) => {
  return await instance.post(market.queryStockDailyCount, data, config);
};

// 获取个股详情的路演数量
export const queryStockRoadShowCount = async (data, config = {}) => {
  return await instance.post(market.getStockRoadShowCount, data, config);
};

// 获取同一股票多地上市信息
export const queryStockSameInfo = async (data, config = {}) => {
  return await instance.post(market.getSameStockInfo, data, config);
};

// 新的公司详情接口（响应 data.stockState 对应 STOCK_STATE：1 上市 / 2 停牌 / 3 退市）
export const queryCompanyDetailLatest = async (data, config = {}) => {
  return await instance.post(market.getStockDetail, data, config);
};

// 用户浏览内容(个股/行业/题材)
export const addUserBrowseDetail = async (data, config = {}) => {
  return await instance.post(common.addUserBrowse, data, config);
};

// 广告位广告列表
export const getAdInfoList = async (data, config = {}) => {
  return await instance.post(market.getAdInfoList, data, config);
};

// 公司研究
export const getCompanyResearch = async (data, config = {}) => {
  return await instance.get(market.getCompanyResearch, data, config);
};

// 重点公司报告-往期报告
export const getPreviousReport = async (data, config = {}) => {
  return await instance.post(market.getPreviousReport, data, config);
};
